import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-avatar',
  template: `
    <div class="user-avatar" [class.user-avatar--lg]="size === 'lg'" [style.background-color]="getAvatarColor()">
      {{getInitials()}}
    </div>
  `,
  styles: [`
    .user-avatar {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      color: #ffffff;
      font-size: 0.72em;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
      letter-spacing: 0.04em;
      flex-shrink: 0;
    }
    .user-avatar--lg {
      width: 56px;
      height: 56px;
      font-size: 1.3em;
      letter-spacing: 0.05em;
    }
  `]
})
export class UserAvatarComponent {
  @Input() user: any;
  @Input() size: 'sm' | 'lg' = 'sm';

  private readonly COLORS = [
    '#1c3f6e', '#2563eb', '#0891b2', '#059669', '#16a34a',
    '#7c3aed', '#db2777', '#0d9488', '#d97706', '#9333ea'
  ];

  getInitials(): string {
    const first = this.user?.name?.trim().charAt(0) || '';
    const last = this.user?.surname?.trim().charAt(0) || '';
    if (first || last) return (first + last).toUpperCase();
    return (this.user?.username || '?').substring(0, 2).toUpperCase();
  }

  getAvatarColor(): string {
    const seed = this.user?.username || '';
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
      hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }
    return this.COLORS[Math.abs(hash) % this.COLORS.length];
  }
}
